export const slider = (slider, isTouchDevice) => {
  let $slider;
  let flkty;

  const init = () => {

    $(slider).removeClass('is-hidden');
    $(slider)[0].offsetHeight; // jshint ignore:line
    $slider  = $(slider).flickity({
      cellSelector: '.js-slider__cell',
      cellAlign: 'center',
      watchCSS: true,
      wrapAround: true,
      imagesLoaded: true,
      lazyLoad: 2,
      prevNextButtons: false,
      pageDots: false
    });

    flkty = $(slider).data('flickity');

    bind();

  };

  const bind = () => {

    var $caption = $('.js-slider__caption');
    var $captionLink = $('.js-slider__caption-link');
    var flkty = $(slider).data('flickity');

    $('.js-slider__btn--previous').on( 'click', function() {
      $(slider).flickity('previous');
    });
    // next
    $('.js-slider__btn--next').on( 'click', function() {
      $(slider).flickity('next');
    });

  };

  if ($(slider).length > 0) {
    init();
  }

};
